import { render } from "./ticketPresta.vue?vue&type=template&id=46f91810"
import script from "./ticketPresta.vue?vue&type=script&lang=ts"
export * from "./ticketPresta.vue?vue&type=script&lang=ts"

import "./ticketPresta.vue?vue&type=style&index=0&id=46f91810&lang=css"
script.render = render

export default script